export const texteReport = {
    "max_chars_nivel": 200,
    "texte_default_nivel": {
        "baza": "Acest nivel determină ce trebuie să stăpânească fiecare elev.",
        "consolidat": "Acest nivel indică faptul că elevul distinge esențialul de detaliu.",
        "avansat": "Acest nivel indică faptul că elevul observă și ce se sugerează, nu doar ceea ce se prezintă în mod direct."
    },
    "texte": {
        "sesiune_inexistenta": "Sesiunea nu există sau raportul nu este disponibil.",
        "durata": {
            "minut": " minut",
            "minute": " minute",
            "ore": "h ",
            "min_curt": " min"
        },
        "etichete_nivel": {
            "standard": {
                "dificultate": "În dificultate",
                "baza": "De bază",
                "consolidat": "Consolidat",
                "avansat": "Avansat"
            },
            "nestandard": {
                "dificultate": "Insuficient",
                "baza": "Suficient",
                "consolidat": "Intermediar",
                "avansat": "Avansat"
            }
        },
        "banda": {
            "standard": {
                "dificultate": "În dificultate",
                "baza": "Nivel de bază",
                "consolidat": "Consolidat",
                "avansat": "Avansat"
            },
            "nestandard": {
                "dificultate": "Insuficient",
                "baza": "Suficient",
                "consolidat": "Intermediar",
                "avansat": "Avansat"
            }
        },
        "empathy": {
            "dificultate": {
                "banda1": {
                    "cu_corecte": "Acest rezultat nu reprezintă un eșec, ci arată că materia este încă în lucru. Vești bune: itemii care reflectă materia stăpânită pot constitui un punct de plecare. Primul pas: exerciții scurte și frecvente pe standardele marcate mai jos (1/2 pe zi).",
                    "fara_corecte": "Nu lăsa rezultatul să te demoralizeze! Lecția/lecțiile predate pot fi parcurse din nou pentru familiarizarea cu materia. Apoi, testul poate fi reluat!",
                },
                "banda2": {
                    "cu_corecte": "Acest rezultat nu reprezintă un eșec, ci arată că materia este încă în lucru. Vești bune: itemii care reflectă materia stăpânită pot constitui un punct de plecare. Primul pas: exerciții scurte și frecvente pe standardele marcate mai jos (1 pe zi).",
                    "fara_corecte": "Nu lăsa rezultatul să te demoralizeze! Lecția/lecțiile predate pot fi parcurse din nou pentru familiarizarea cu materia. Apoi, testul poate fi reluat!"
                },
                "banda3": {
                    "cu_corecte": "Mai este puțin până la nivelul următor! Câteva exerciții în plus pe zi vor asigura obținerea unui rezultat mai bun!",
                    "fara_corecte": "Nivelul următor este foarte aproape! Cu puțin exercițiu se va obține un rezultat mai bun.",
                }
            },
            "baza": {
                "banda1": "Rezultatul obținut este bun! Continuă testarea pentru a trece la nivelul următor!",
                "banda2": "Rezultatul obținut este bun! Continuă testarea pentru a trece la nivelul următor!",
                "banda3": "Nivelul următor este foarte aproape! Continuă exercițiile pentru aprofundarea materiei și sedimentarea cunoștințelor."
            },
            "consolidat": {
                "banda1": "Felicitări! Rezultatul obținut este foarte bun! Cu puțin efort se poate ajunge rapid la următorul nivel.",
                "banda2": "Felicitări! Rezultatul tău este foarte bun! Cu puțin efort se poate ajunge rapid la următorul nivel.",
                "banda3": "Excelent! A mai rămas puțin până la nivelul următor! Câteva exerciții în plus pe săptămână vor asigura obținerea notei maxime."
            },
            "avansat": {
                "banda1": "Felicitări pentru rezultatul excelent! Nota maximă este foarte aproape. Continuă testarea pentru un rezultat perfect!",
                "banda2": "Felicitări pentru rezultatul excelent! Nota maximă este foarte aproape. Continuă testarea pentru un rezultat perfect!",
                "banda3": "Rezultatul obținut este excelent! Continuă testarea în același ritm pentru un parcurs educațional constant."
            }
        },
        "indicatori": {
            "intrebari_usoare": {
                "label": "Întrebări ușoare ratate",
                "singular": " întrebare ușoară ratată",
                "plural": " întrebări ușoare ratate"
            },
            "viteza": {
                "label": "Viteza de lucru",
                "singular": " secundă pe întrebare",
                "plural": " secunde pe întrebare",
                "nenotat": "—"
            },
            "constanta": {
                "label": "Constanța pe parcurs"
            }
        },
        "ce_urmeaza": {
            "cel_slab": "Este necesară concentrarea pe „%s”: exerciții scurte și frecvente pe %s, 1–2 pe zi.",
            "cel_slab_context": {
                "standard": "acest standard",
                "nestandard": "acest conținut"
            },
            "fara_slab": "Sunt necesare exercițiile scurte și frecvente, 1–2 pe zi, pentru a consolida baza.",
            "neatentie": "Este nevoie de atenție la %d%s: citirea cerinței înainte de a răspunde.",
            "neatentie_singular": " întrebare pierdută din neatenție",
            "neatentie_plural": " întrebări pierdute din neatenție",
            "fara_neatentie": "Nu a fost înregistrată nicio greșeală din neatenție.",
            "cel_puternic": "„%s” constituie punctul de plecare — este necesară o revizuire periodică pentru menținere.",
            "fara_puternic": {
                "standard": "Reia de la standardele marcate mai sus: testează zilnic pe cel mai slab.",
                "nestandard": "Reia de la conținuturile marcate mai sus: testează zilnic pe cea mai slabă."
            }
        },
    }
};